import { map, omit, concat } from 'lodash'
import { http, queryString } from 'utils'

// User mutation imports.
import { SET_LIST} from 'vx/mutations'



// Contact state.
const state = {
  budgets: []
}

// User state getters.
const getters = {
  /**
   * User state as a decorated object.
   */
  budgets: state => state.budgets,

  getById: (state) => (id) => {
    return state.budgets.find(budget => budget.id === id)
  }
}

// User actions.
const actions = {

  /**
   * Get a list of budgets.
   */
  getBudgets ({ commit }, payload) {
    return http.get(`/budgets/list`, {params: payload}).then(response => {
      commit(SET_LIST, response.data)

      return response
    })
  },
}

// User state mutations.
const mutations = {
  
  /**
  * Set the clients state.
  */
  [SET_LIST] (state, budgets) {
    state.budgets = budgets
  }
}

// Export our state, getters, actions, mutations, and modules.
export default {
  namespaced: true, state, getters, actions, mutations
}
